export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 w-full">
              <div className="relative w-full aspect-[4/3] rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20digital%20newsroom%20concept%20with%20warm%20ambient%20lighting%2C%20multiple%20floating%20screens%20displaying%20breaking%20news%2C%20dark%20sleek%20environment%20with%20crimson%20accent%20lights%2C%20professional%20editorial%20atmosphere%2C%20cinematic%20composition%2C%20clean%20and%20sophisticated%20design%20aesthetic&width=1200&height=900&seq=about-911-01&orientation=landscape"
                  alt="911爆料网 - 品牌介绍"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-black/30 to-transparent"></div>
              </div>
            </div>

            <div className="flex-1 w-full">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
                关于 <span className="text-primary-500">911爆料网</span>
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                911爆料网成立于2024年，是国内领先的一站式吃瓜黑料内容聚合平台。我们致力于为吃瓜群众提供最新、最全、最热的爆料内容，涵盖娱乐八卦、社会事件、网红翻车、明星动态等多个领域。通过智能聚合与人工精选相结合的方式，确保每一条内容都经过严格筛选，为用户打造高品质的吃瓜体验。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                平台集结了全网911吃瓜黑料最新合集，覆盖图文、视频、时间线等多种内容形态。我们的编辑团队7×24小时不间断追踪热点，第一时间整理发布，让广大吃瓜群众不错过任何一个精彩爆料。
              </p>
              <div className="flex flex-wrap gap-3">
                {['内容全面', '更新及时', '来源可靠', '体验流畅'].map((tag) => (
                  <span
                    key={tag}
                    className="px-4 py-1.5 text-xs font-medium bg-primary-100 text-primary-700 rounded-full whitespace-nowrap"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}